import { render, staticRenderFns } from "./CreateBook.vue?vue&type=template&id=6494f1fe&scoped=true"
import script from "./CreateBook.vue?vue&type=script&lang=js"
export * from "./CreateBook.vue?vue&type=script&lang=js"
import style0 from "./CreateBook.vue?vue&type=style&index=0&id=6494f1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6494f1fe",
  null
  
)

export default component.exports